import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  iban: {
    name: FieldName.iban,
    label: "IBAN",
    placeholder: `${i18n._(
      t({
        id: "placeholder.example",
        message: "e.g.",
      })
    )} SM86 U032 2509 8000 0000 0270 100`,
    instructions: i18n._(
      t({
        id: "fields-config.iban.instructions",
        message: "International Bank Account Number",
      })
    ),
  },
  local: [
    {
      name: FieldName.bankCode,
      label: "Codice ABI",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 05428`,
      instructions: i18n._(
        t({
          id: "fields-config.bank-code.instructions",
          message: "Bank code",
        })
      ),
    },
    {
      name: FieldName.branchCode,
      label: "CAB",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 11101`,
      instructions: i18n._(
        t({
          id: "fields-config.branch-code.instructions",
          message: "Branch code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Numero di conto",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 123456`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
  ],
  primaryBankDetailsFields: [FieldName.iban],
  secondaryBankDetailsField: [
    FieldName.bankCode,
    FieldName.branchCode,
    FieldName.accountNumber,
  ],
});
